import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { SafeAnchor } from '../SafeAnchor';
const FirstItem = (props)=>{
    let contents = props.children;
    if (!contents) {
        contents = /*#__PURE__*/ _jsx("span", {
            "aria-hidden": "true",
            children: '\u00ab'
        });
    }
    return /*#__PURE__*/ _jsx(PaginationItem, {
        ...props,
        children: contents
    });
};
const LastItem = (props)=>{
    let contents = props.children;
    if (!contents) {
        contents = /*#__PURE__*/ _jsx("span", {
            "aria-hidden": "true",
            children: '\u00bb'
        });
    }
    return /*#__PURE__*/ _jsx(PaginationItem, {
        ...props,
        children: contents
    });
};
const PrevItem = (props)=>{
    let contents = props.children;
    if (!contents) {
        contents = /*#__PURE__*/ _jsx("span", {
            "aria-hidden": "true",
            children: '\u2039'
        });
    }
    return /*#__PURE__*/ _jsx(PaginationItem, {
        ...props,
        children: contents
    });
};
const NextItem = (props)=>{
    let contents = props.children;
    if (!contents) {
        contents = /*#__PURE__*/ _jsx("span", {
            "aria-hidden": "true",
            children: '\u203a'
        });
    }
    return /*#__PURE__*/ _jsx(PaginationItem, {
        ...props,
        children: contents
    });
};
const EllipsisItem = (props)=>{
    let contents = props.children;
    if (!contents) {
        contents = /*#__PURE__*/ _jsx("span", {
            "aria-hidden": "true",
            children: '\u2026'
        });
    }
    return /*#__PURE__*/ _jsx(PaginationItem, {
        ...props,
        children: contents
    });
};
const PaginationItem = (props)=>{
    const { className, active, disabled, children, ...rest } = props;
    const bsClass = classnames('page-item', {
        active: !!active
    }, {
        disabled: !!disabled
    }, className);
    return /*#__PURE__*/ _jsx("li", {
        className: bsClass,
        children: /*#__PURE__*/ _jsx(SafeAnchor, {
            className: "page-link",
            disabled: disabled,
            ...rest,
            children: children
        })
    });
};
export { PaginationItem, FirstItem, LastItem, PrevItem, NextItem, EllipsisItem };
